import { Spinner } from '../../Spinner'

/** @public @react */
export function TldrawUiButtonSpinner() {
	return <Spinner />
}
